import React from 'react';
import { Field } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';

import { FormGroupField } from 'components/Form';
import InspectHeader from 'components/InspectHeader';

import './style.scss';

const ContextCreate = () => (
  <div styleName="root">
    <InspectHeader />

    <Grid styleName="inner">
      <Row>
        <Col xs={12}>
          <Field
            type="text"
            name="create-new-context"
            data-test="context-name"
            label="CONTEXT NAME"
            placeholder="Type Context Name"
            component={FormGroupField}
          />
        </Col>
      </Row>
    </Grid>
  </div>
);

export default ContextCreate;
